import { LogLevel } from '@azure/msal-browser';

/**
 * Multitenant + personal Microsoft accounts (v2 common).
 * Redirect URI must match Entra "Single-page application" URIs exactly (path included).
 * RD-Auth-Dev-Portal registers e.g. http://localhost:3001/callback — not the bare origin.
 */
export function createMsalConfiguration() {
  const clientId = (process.env.REACT_APP_AZURE_CLIENT_ID || '').trim();
  if (!clientId) {
    console.error(
      'REACT_APP_AZURE_CLIENT_ID is missing. Set it in .env.local or .env.local.fullstack to your Entra SPA Application (client) ID. Without it, Microsoft shows AADSTS700038 for 00000000-0000-0000-0000-000000000000.',
    );
  }

  const rawPath = (process.env.REACT_APP_MSAL_REDIRECT_PATH || '/callback').trim() || '/callback';
  const redirectPath = rawPath.startsWith('/') ? rawPath : `/${rawPath}`;
  const redirectBase = `${window.location.origin.replace(/\/$/, '')}${redirectPath}`;

  return {
    auth: {
      clientId: clientId || '00000000-0000-0000-0000-000000000000',
      authority: 'https://login.microsoftonline.com/common',
      redirectUri: redirectBase,
      postLogoutRedirectUri: redirectBase,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    },
    system: {
      loggerOptions: {
        logLevel: LogLevel.Error,
      },
    },
  };
}

export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};

/** Session keys used for full-page redirect return to Funnel Fuel (same-origin on this SPA only). */
export const SSO_SESSION_KEYS = {
  parentOrigin: 'funnel_sso_parent_origin',
  returnPath: 'funnel_sso_return_path',
};

/**
 * How Microsoft sign-in is invoked.
 * - redirect (default): full-page navigation + MSAL handleRedirectPromise (recommended).
 * - popup: nested MSAL popup from this SPA (Funnel Fuel opened this app in a window).
 */
export function getConfiguredInteractionMode() {
  const raw = (process.env.REACT_APP_MSAL_INTERACTION_MODE || 'redirect').trim().toLowerCase();
  return raw === 'popup' ? 'popup' : 'redirect';
}
